<template>
    <Head>
        <title>Fiat Gateway: Реквизиты</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <div class="grid grid-cols-6 bg-white p-6 gap-6">
            <v-input-json v-model="settings"/>
            <v-input label="ex"/>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VInputJson from '@/Components/InputJson';
import VInput from '@/Components/Input';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VInputJson,
        VInput,
    },
    props: {
        notifications: Array,
    },
    data() {
        return {
            settings: {
                minCommissionAmount: [8,5],
                commissionPercent: 101,
                gatewayCurrencyID: '',
            },
        }
    },

};
</script>
